import Vue from 'vue'
import Router from 'vue-router'

// Import Pages
import Home from '@/pages/Home'
import Contact from '@/pages/Contact'
import About from '@/pages/About'
import MapResults from '@/pages/MapResults'
import Partnerships from '@/pages/Partnerships'
import Partnership from '@/pages/Partnership'
import FOFError from '@/pages/FOFError'
import RequestListing from '@/pages/RequestListing'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/map-results/:state_province_slug',
      name: 'MapResults',
      component: MapResults
    },
    {
      path: '/partnerships',
      name: 'Partnerships',
      component: Partnerships
    },
    {
      path: '/partnership/:partnership_slug',
      name: 'Partnership',
      component: Partnership
    },
    {
      path: '/request-listing',
      name: 'RequestListing',
      component: RequestListing
    },
    {
      path: '*',
      name: 'FOFError',
      component: FOFError
    }
  ],
  scrollBehavior (to, from, savedPosition) { // controls navigation behavior
    if (savedPosition) {
      return savedPosition // if savedPosition is filled, then navigate there
    } else if (to.hash) {
      return { selector: to.hash } // simulated scroll-to-anchor behavior
    } else {
      return {x: 0, y: 0} // else scroll to top
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js